import { render, staticRenderFns } from "./FormStamp.vue?vue&type=template&id=88b0b5e6&scoped=true&"
import script from "./FormStamp.vue?vue&type=script&lang=js&"
export * from "./FormStamp.vue?vue&type=script&lang=js&"
import style0 from "./FormStamp.vue?vue&type=style&index=0&id=88b0b5e6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b0b5e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VSelect,VSheet,VTextField})
